import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function ScarcityBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storageKey = 'lp3_scarcity_deadline';
    let deadline = localStorage.getItem(storageKey);
    if (!deadline) {
      const d = new Date();
      d.setDate(d.getDate() + 2);
      deadline = d.toISOString();
      localStorage.setItem(storageKey, deadline);
    }
    const deadlineDate = new Date(deadline);
    const update = () => {
      const now = new Date();
      const diff = deadlineDate.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(diff % (1000 * 60) / 1000);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds
      });
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const isExpired = timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;
  return <motion.div initial={{
    y: -40,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="w-full bg-navy-dark/90 border-b border-gold/20 relative overflow-hidden sticky top-0 z-50 backdrop-blur-sm" data-id="element-574">
      <div className="relative py-1.5 px-4" data-id="element-575">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 sm:gap-4 flex-wrap" data-id="element-576">
          {/* Label */}
          <span className="font-heading font-bold text-white text-[11px] sm:text-xs tracking-wide" data-id="element-577">
            {isExpired ? 'El precio ha subido a $97' : 'Precio de $27 expira en'}
          </span>

          {/* Compact countdown */}
          {!isExpired && <span className="font-heading font-black text-gold text-[11px] sm:text-xs tabular-nums" data-id="element-578">
              {pad(timeLeft.days)}d : {pad(timeLeft.hours)}h :{' '}
              {pad(timeLeft.minutes)}m : {pad(timeLeft.seconds)}s
            </span>}

          {/* Compact CTA */}
          <a href="/checkout" onClick={() => {
          if ((window as any).fbq) (window as any).fbq('track', 'AddToCart', {
            content_name: 'AI Web Closer Course',
            content_type: 'product',
            value: 27,
            currency: 'USD'
          });
        }} className="font-heading font-bold text-[10px] sm:text-[11px] text-navy bg-gold hover:bg-gold-light px-3 py-1 rounded uppercase tracking-wide transition-colors" data-id="element-579">
            Asegurar $27
          </a>
        </div>
      </div>
    </motion.div>;
}